module.exports = __webpack_public_path__ + "static/media/Copper.41589902.jpg";